const useEmptyCardFooterAction = () => {
  return {
    primaryActionConfig: null
  };
};
export default useEmptyCardFooterAction;